// extracted by mini-css-extract-plugin
export default {"cholquvar":"cho'lquvar_cholquvar__cKu6B"};